import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PagedResult } from '../models/product.models';
import {
  PurchaseDto,
  PurchaseListItemDto,
  PurchaseStatus,
  CreatePurchaseRequest,
} from '../models/finance.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PurchaseService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Purchases`;

  getAll(
    page: number,
    pageSize: number,
    opts?: {
      storeId?: string;
      supplierId?: string;
      status?: PurchaseStatus;
      from?: string;
      to?: string;
    },
  ): Observable<ApiResponse<PagedResult<PurchaseListItemDto>>> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (opts?.storeId) params = params.set('storeId', opts.storeId);
    if (opts?.supplierId) params = params.set('supplierId', opts.supplierId);
    if (opts?.status) params = params.set('status', opts.status);
    if (opts?.from) params = params.set('from', opts.from);
    if (opts?.to) params = params.set('to', opts.to);
    return this.http.get<ApiResponse<PagedResult<PurchaseListItemDto>>>(this.endpoint, { params });
  }

  getById(id: string): Observable<ApiResponse<PurchaseDto>> {
    return this.http.get<ApiResponse<PurchaseDto>>(`${this.endpoint}/${id}`);
  }

  create(data: CreatePurchaseRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.endpoint, data);
  }

  /**
   * Mavjud kirim hujjatiga yetkazib beruvchi biriktiradi.
   *
   * Yetkazuvchisiz qarzni to'lab bo'lmaydi — to'lov faqat yetkazuvchi orqali
   * yoziladi. Yangi hujjatlarda bu holat to'sildi, bu esa eski qatorlarni
   * tuzatish uchun. Faqat biriktiradi: summa va sanalarga tegilmaydi.
   */
  assignSupplier(id: string, supplierId: string): Observable<unknown> {
    return this.http.put(`${this.endpoint}/${id}/supplier`, { supplierId });
  }

  delete(id: string): Observable<unknown> {
    return this.http.delete(`${this.endpoint}/${id}`);
  }
}
